/**
 * Created by jv on 2020-02-07 (12:11).
 */
import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/school/school.html";
import ClassTemplate from "Views/partials/school/school-class.html";
import ClassService from "Sources/services/class-service";

import "Styles/components/school.scss";

class School
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.school = options.school;
    this.onRemove = options.onRemoveClicked;
    this.onClassRemove = options.onClassRemoveClicked;
    this.showGlobalError = options.showGlobalError;
    this.studentCount = 0;
    this.classToRemove;
  }

  get school()
  {
    return this._school;
  }

  set school(school)
  {
    this._school = school;
    this.updateSchool();
  }

  static setUpSchool(options)
  {
    let instance = new School(options);
    instance.render();
    instance.setUpEventListeners();
    return instance;
  }

  setUpEventListeners()
  {
    const REMOVESCHOOL_BTN_ID = ".delete-school-btn";

    let that = this;
    this.$element.find(REMOVESCHOOL_BTN_ID).on("click", function(e)
    {
      e.preventDefault();
      that.removeSchool();
    });
  }


  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.prepend(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateSchool();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateSchool() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $schoolName = this.$element.find("[data-bind-target='school-name']");
      $schoolName.empty();

      if (utils.isNotNull(this.school) && utils.isNotNull(this.school.name)) {
        $schoolName.text(this.school.name);
      }

      let $addressLineStreet = this.$element.find("[data-bind-target='address-line-street']");
      $addressLineStreet.empty();

      if (utils.isNotNull(this.school) && utils.isNotNull(this.school.addressLineStreet)) {
        $addressLineStreet.text(this.school.addressLineStreet);
      }

      let $addressLineCity = this.$element.find("[data-bind-target='address-line-city']");
      $addressLineCity.empty();

      if (utils.isNotNull(this.school) && utils.isNotNull(this.school.addressLineCity)) {
        $addressLineCity.text(this.school.addressLineCity);
      }

      let $phoneNumber = this.$element.find("[data-bind-target='phone-number']");
      $phoneNumber.empty();

      if (utils.isNotNull(this.school) && utils.isNotNull(this.school.phoneNumber)) {
        $phoneNumber.text(this.school.phoneNumber);
      }

      if (utils.isNotNull(this.school.key)) {
        let $addClassButton = this.$element.find("[data-bind-target='create-class-button']");
        $addClassButton.attr("href", "create-class/" + this.school.key);
      }

    }
  }

  updateClasses(){
    let $classes = this.$element.find("[data-bind-target='school-classes']");
    $classes.empty();

    this.school.schoolClasses.forEach((schoolClass) => {
      let $element = $(ClassTemplate);
      let $className = $element.find("[data-bind-target='class-name']");
      $className.text(schoolClass.name);
      let $pupilCount = $element.find("[data-bind-target='pupil-count']");
      $pupilCount.text(schoolClass.studentCount);
      $element.attr("href", "/edit-class/" + schoolClass.key);

      let that = this;
      $element.find(".remove-class-btn").on("click", function(e)
      {
        e.preventDefault();
        that.classToRemove = schoolClass.key;
        that.onClassRemove(that.school.key);
      });

      $classes.append($element);
      LanguageManager.applyLocale($element);
    });
  }

  removeClass() {
    let that = this;

    ClassService.deleteClass(this.classToRemove).then(function(){
      that.school.schoolClasses.splice(that.school.schoolClasses.findIndex(schoolClass => schoolClass.key === that.classToRemove), 1);
      that.updateClasses();
      //this.showGlobalError("success");

    })
    .catch((appError) =>
    {
      this.showGlobalError(appError.code);
      log.error("could not delete class");
    });

  }

  removeSchool() {
    this.onRemove(this.school.key);
  }

  showClass(schoolClass) {
    this.school.schoolClasses.push(schoolClass);
    this.updateClasses();
  }

}

export default School;



// WEBPACK FOOTER //
// ./app/js/components/school.js